import { Button } from "components/button/Button";
import { MessageItem } from "models/inbox/inbox";
import config from "config/config";
import { getTabToken } from "common/MetaActions";
import { downloadAndSaveFile } from "common/downloadFile";
import Message from "views/inbox/components/message/Message";
import { useRootStore } from "store";

type Props = {
  messageList: MessageItem[];
  loadInbox: () => void;
};

export default function SentMessageList({ messageList, loadInbox }: Props) {
  const { user: currentUser } = useRootStore((state) => state);
  const { workingCustomerId } = useRootStore((state) => state.global);

  const handleOpenDocument = (item: { id: string; name: string }) => {
    const url = config.api.archive.download(workingCustomerId, item.id);
    const headers = new Headers();
    headers.append("Authorization", `Bearer ${getTabToken()}`);
    downloadAndSaveFile(url, item.name, headers);
  };

  return (
    <>
      <h1>Skickade meddelanden</h1>
      <hr className={"header-border"} />
      {messageList.length === 0 && (
        <>
          <p>
            Hoppsan, här var det tomt. Klicka på Ny konversation för att skicka
            ett meddelande.
          </p>

          <Button variant="outline" size="sm" onClick={loadInbox}>
            Ladda om inkorgen
          </Button>
        </>
      )}

      {currentUser &&
        messageList.map((message) => {
          return (
            <Message
              showRecipients={true}
              canDeleteMessage={false}
              key={message.messageId}
              sender={{
                firstName: currentUser.userInfo
                  ? currentUser.userInfo.givenName
                  : "",
                lastName: currentUser.userInfo
                  ? currentUser.userInfo.surName
                  : ""
              }}
              message={message}
              onOpenDocument={handleOpenDocument}
            />
          );
        })}
    </>
  );
}
